import React from "react";

const cartIconPath =
  "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2S15.9 22 17 22s2-.9 2-2-.9-2-2-2zM7.16 14h9.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1 1 0 0021 5H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7.42c-.14 0-.25-.11-.26-.25l.01-.04L7.16 14z";

const CartButton = ({ count, onClick, className = "" }) => {
  return (
    <button
      onClick={onClick}
      className={`relative rounded-xl bg-gray-50 text-gray-700 transition-all hover:bg-primary-50 hover:text-primary-600 ${className}`}
      aria-label="Open cart"
    >
      <svg className="h-full w-full" viewBox="0 0 24 24" fill="currentColor">
        <path d={cartIconPath} />
      </svg>
      {count > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs text-white shadow-lg sm:h-6 sm:w-6 sm:text-sm">
          {count}
        </span>
      )}
    </button>
  );
};

export default CartButton;
